<template>
  <div class="control-bar-nav">
    <button
      type="button"
      class="scrollControlBar__btn"
      @click="$emit('scroll-top')"
    >
      回到顶部
    </button>
    <span class="scrollControlBar__sep" aria-hidden="true"></span>
    <button
      type="button"
      class="scrollControlBar__btn scrollControlBar__btn--primary"
      @click="$emit('open-filter')"
    >
      筛选与操作
    </button>
  </div>
</template>

<script>
/**
 * 滚动态居中导航：视觉与改前 scrollControlBar__actions 内文字按钮一致。
 */
export default {
  name: 'ControlBarNav',
}
</script>

<style scoped>
.control-bar-nav {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
}
</style>
